import apiClient from '../utils/apiClient'

const RESOURCES = new Set(['requests', 'clients'])

function positiveId(value, field) {
	const id = String(value ?? '')
	if (!/^[1-9]\d*$/.test(id)) throw new TypeError(`Invalid ${field}`)
	return id
}

function nullableMembershipId(value) {
	return value === null ? null : positiveId(value, 'assigneeMembershipId')
}

export function normalizeAssignment(value) {
	return Object.freeze({
		resourceId: positiveId(value?.resourceId, 'resourceId'),
		assigneeMembershipId: nullableMembershipId(value?.assigneeMembershipId),
	})
}

export class ResourceAssignmentApi {
	constructor(http = apiClient) { this.http = http }

	async assign(resource, resourceId, assigneeMembershipId) {
		if (!RESOURCES.has(resource)) throw new TypeError('Invalid resource')
		const id = positiveId(resourceId, 'resourceId')
		return normalizeAssignment((await this.http.put(`/api/${resource}/${id}/assignee`, {
			assigneeMembershipId: nullableMembershipId(assigneeMembershipId),
		})).data)
	}
}

export default new ResourceAssignmentApi()
